'use client'
import { useEffect, useRef } from 'react'
import Image from 'next/image'

import { MdBeachAccess } from "react-icons/md";
import { FaWater } from "react-icons/fa";
import { IoMdVideocam } from 'react-icons/io'
import { BiArea, BiSolidArea } from "react-icons/bi";
import { FaBed, FaBath } from "react-icons/fa"
// import { sendLike } from '@services/sendLike'
import CurrencySymbol from '@components/CurrencySymbol'

import tailwindConfig from '@tailwind.config'
import LinkComponent from '@components/LinkComponent'
import { sendGAEvent } from '@next/third-parties/google'

const LargePropertyCard = ({ property, imageWidth = 300, imageHeight = 200, includeInactive = false, newLimit, isLast, district = undefined, dictionary, lang, saleType }) => {
    const style = {
        color: tailwindConfig.theme.extend.colors.secondary,
        height: 90,
        overflow: 'hidden',
        z: 10
    };

    // const [showLikeBtn, setShowLikeBtn] = useState(false)
    // const [isLiked, setIsLiked] = useState(property.isLiked)
    // const { data: session } = useSession()

    const cardRef = useRef();

    // const handleLike = async () => {
    //     const isLike = await sendLike(property.id)
    //     setIsLiked((prevLike) => !prevLike)
    //     property.isLiked = !property.isLiked
    // };

    useEffect(() => {
        if (!cardRef?.current) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (isLast && entry.isIntersecting) {
                newLimit();
                observer.unobserve(entry.target);
            }
        });

        observer.observe(cardRef.current);
    }, [isLast]);

    // useEffect(() => {
    //     if (session !== null) {
    //         setShowLikeBtn(true)
    //     }
    // }, [])

    let location = 'Pattaya'

    switch (lang) {
        case 'en':
            location = 'Pattaya'
            break;
        case 'th':
            location = 'พัทยา'
            break;
        case 'cn':
            location = '芭提雅'
            break;
        default:
            break;
    }

    // const isSmallDevice = window.innerWidth < 768;
    // const isTablet = window.innerWidth < 1024;

    return (
        <div className={`sm:w-[${imageWidth}px] w-full rounded-lg shadow-md hover:shadow-sm hover:shadow-maincolor`}
            ref={cardRef}
            onClick={() => sendGAEvent({ 
                event: "select_property",
                property_id: property.ref,
                property_name: property.name,
                property_type: property.metaCategory,
                property_location: property.districts[0]?.subdistrictName?.['en'],
            })} 
        >
            <LinkComponent
                href={'/properties/' + property.slug}
            >
                <div>
                    <div className='relative'>
                        <Image
                            placeholder="blur"
                            blurDataURL={property.blur}
                            className='sm:w-[300px] w-full aspect-[4/3] rounded-t-md overflow-hidden'
                            src={property.cover}
                            width={imageWidth}
                            height={imageHeight}
                            alt={property.slug}
                        />
                        {(property.videoUrl || property.isSeaView || property.isBeachfront || property.isMountainView || property.foreignQuota) ? (
                            <div className='absolute w-full bottom-1 left-1 flex flex-row flex-wrap'>
                                {/* {(property.foreignQuota && property.category == 'Condo' && property.saleType == 'sale') ? (
                                    <div className={`rounded-md p-1 text-third border-third border-[1px] text-sm mr-1 flex flex-row items-center`}><MdPlaylistAddCheckCircle /><span className='ml-1'>Foreign Quota</span></div>
                                ) : null} */}
                                {property.videoUrl ? (
                                    <div className={`rounded-md p-1 text-light bg-red-800 text-sm mr-1 flex flex-row items-center`}><IoMdVideocam /><span className='ml-1'>{dictionary.video}</span></div>
                                ) : null}
                                {property.isSeaView ? (
                                    <div className={`rounded-md p-1 bg-maincolor text-light border-light border-[1px] text-sm mr-1 flex flex-row items-center`}><FaWater /><span className='ml-1'>{dictionary.seaView}</span></div>
                                ) : null}
                                {property.isBeachfront ? (
                                    <div className={`rounded-md p-1 bg-third text-light border-third border-[1px] text-sm mr-1 flex flex-row items-center`}><MdBeachAccess /><span className='ml-1'>{dictionary.beachfront}</span></div>
                                ) : null}
                                {/* {property.isMountainView ? (
                                    <div className={`rounded-md p-1 text-secondary border-secondary border-[1px] text-sm mr-1 flex flex-row items-center`}><FaMountain /><span className='ml-1'>Mountain View</span></div>
                                ) : null} */}
                            </div>
                        ) : null}
                        {property.isPromotion && (
                            <div className='absolute left-2 top-2 bg-third text-light p-1 rounded-md z-10 font-semibold'>{property.promotionTitle}</div>
                        )}
                    </div>
                    <div className='sm:w-[300px] w-full p-2'>
                        <div width={imageWidth} className='text-xl font-semibold text-maincolor relative flex flex-col justify-between sm:overflow-hidden sm:h-[85px] h-full' title={property.enName}>
                            <h2 className='line-clamp-3'>
                                {property.name}
                            </h2>
                            {/* <div className='relative w-full flex flex-row-reverse'> */}
                            {/* <div className='absolute z-40 right-0 left-0 top-[-30px] h-[30px] bg-gradient-to-b from-transparent to-light'></div> */}
                            <div className='sm:absolute z-40 right-0 left-0 bottom-0 sm:h-[30px] h-0 '></div>
                            {/* </div> */}
                        </div>
                        {/* <div className='w-full text-maincolor text-xl font-semibold flex flex-wrap rounded-r-md z-10'><h3>{property.name}</h3></div> */}
                        <div className='flex flex-row w-full'>
                            {(property.salePrice && saleType == 'sale') && (
                                <div className='text-xl font-semibold text-third w-1/2'><CurrencySymbol />{property.salePrice}</div>
                            )}
                            {(property.rentPrice && saleType == 'rent') && (
                                <div className='text-xl font-semibold text-third w-1/2'><CurrencySymbol />{property.rentPrice}/{dictionary.month}</div>
                            )}
                            {(saleType == '' || saleType == undefined) && property.salePrice !== undefined && (
                                <div className='text-xl font-semibold text-third w-1/2'><CurrencySymbol />{property.salePrice}</div>
                            )}
                            {(saleType == '' || saleType == undefined) && property.rentPrice !== undefined && (
                                <div className='text-xl font-semibold text-third w-1/2'><CurrencySymbol />{property.rentPrice}/{dictionary.month}</div>
                            )}
                        </div>
                        <div className='w-full border-b-[1px] border-forth pb-1 mb-1'>
                            <p className='text-secondary text-xl'>{property.districts[0]?.subdistrictName?.[lang] ? property.districts[0]?.subdistrictName?.[lang] : property.districts[0]?.subdistrict}, {location}</p>
                        </div>
                        {(property.category == 'Condo' || property.category == 'House' || property.category == 'Poolvilla' || property.category == 'Commercial') &&
                            <div className='flex flex-row w-full'>
                                <div className='flex flex-row items-center w-1/2'>
                                    <FaBed
                                        color={tailwindConfig.theme.extend.colors.secondary}
                                    />
                                    {(property.bedrooms && (property.bedrooms > 0 || typeof property.bedrooms == 'string')) ? (
                                        <span className='ml-2 text-xl text-maincolor'>{property.bedrooms} {typeof property.bedrooms !== 'string' ? dictionary.beds : ''}</span>
                                    ):null}
                                </div>
                                {(property.bathrooms && property.bathrooms > 0) ? (
                                    <div className='flex flex-row items-center w-1/2'>
                                        <FaBath
                                            color={tailwindConfig.theme.extend.colors.secondary}
                                        />
                                        <span className='ml-2 text-xl text-maincolor'>{property.bathrooms} {dictionary.baths}</span>
                                    </div>
                                ):null}
                            </div>
                        }
                        <div className='flex flex-row w-full justify-between min-h-7'>
                            {(property.livingArea && property.livingArea > 0) ? (
                                <div className='flex flex-row items-center w-1/2'>
                                    <BiArea
                                        color={tailwindConfig.theme.extend.colors.secondary}
                                    />
                                    <span className='ml-2 text-xl text-maincolor'>{property.livingArea} {dictionary.sqm}</span>
                                </div>
                            ): null}
                            {(property.landArea && property.landArea > 0) ? (
                                <div className='flex flex-row items-center w-1/2'>
                                    <BiSolidArea
                                        color={tailwindConfig.theme.extend.colors.secondary}
                                    />
                                    <span className='ml-2 text-xl text-maincolor'>{property.landArea} {dictionary.sqm}</span>
                                </div>
                            ):null}
                        </div>
                    </div>
                </div>
            </LinkComponent >
        </div>
    )
}

export default LargePropertyCard